var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { injectable } from 'inversify';
import { validateOrReject } from 'class-validator';
var GroupsService = /** @class */ (function () {
    function GroupsService() {
        this.apiBase = '/api/v1';
        this.endpoint = this.apiBase + "/groups";
        this.adminUserToGroupEndpoint = this.apiBase + "/admin/group-users";
        this.updateUserRoleEndpoint = this.apiBase + "/admin/group-roles";
        this.groupJoinRequestsEndpoint = this.apiBase + "/group-join-requests";
        this.groupUserEndpoint = this.apiBase + "/group-users";
        this.membershipInvitationEndpoint = this.apiBase + "/group-invitations";
        this.membershipInvitationLinkEndpoint = this.apiBase + "/group-invitation-links";
    }
    GroupsService.prototype.createGroup = function (group) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, validateOrReject(group)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, axios.post(this.endpoint, group.toRestModel())];
                }
            });
        });
    };
    GroupsService.prototype.updateGroup = function (group) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, validateOrReject(group)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, axios.patch(this.endpoint + "/" + group.uuid, group.toRestModel())];
                }
            });
        });
    };
    GroupsService.prototype.updateGroupProfileLogo = function (groupUuid, logo, profile_image) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = new FormData();
                formData.append('_method', 'PATCH');
                formData.append('logo', logo);
                formData.append('profile_image', profile_image);
                return [2 /*return*/, axios.post(this.endpoint + "/" + groupUuid + "/uploads", formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })];
            });
        });
    };
    GroupsService.prototype.updateGroupLogo = function (groupUuid, file) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.append('logo', file);
                        formData.append('_method', 'PATCH');
                        return [4 /*yield*/, axios.post(this.endpoint + "/" + groupUuid + "/logo", formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupsService.prototype.addImage = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.append('file', file);
                        return [4 /*yield*/, axios.post(this.apiBase + "/attachments", formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupsService.prototype.updateGroupProfileImage = function (groupUuid, file) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.append('profile_image', file);
                        formData.append('_method', 'PATCH');
                        return [4 /*yield*/, axios.post(this.endpoint + "/" + groupUuid + "/profile-image", formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupsService.prototype.addUserToGroup = function (model) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, validateOrReject(model)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, axios.post(this.adminUserToGroupEndpoint, model.toModel())];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GroupsService.prototype.updateUserRole = function (model) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, validateOrReject(model)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, axios.patch(this.updateUserRoleEndpoint, model.toModel())];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GroupsService.prototype.updateGroupUserRole = function (groupUuid, user_id, group_role) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.patch(this.endpoint + "/" + groupUuid + "/roles", { user_id: user_id, group_role: group_role })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupsService.prototype.updateJoinRequestState = function (joinReqId, approve) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios.patch(this.groupJoinRequestsEndpoint + "/" + joinReqId + "/" + (approve ? 'approve' : 'deny'))];
            });
        });
    };
    GroupsService.prototype.deleteGroup = function (uuid) {
        return axios.delete(this.endpoint + "/" + uuid);
    };
    GroupsService.prototype.leaveGroup = function (groupUserId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios.delete(this.groupUserEndpoint + "/" + groupUserId)];
            });
        });
    };
    GroupsService.prototype.removeGroupUser = function (groupUserId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios.delete(this.adminUserToGroupEndpoint + "/" + groupUserId)];
            });
        });
    };
    GroupsService.prototype.joinOpenGroup = function (groupId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios.post(this.groupUserEndpoint + "/", {
                        group_id: groupId,
                    })];
            });
        });
    };
    GroupsService.prototype.requestToJoinGroup = function (groupId, text) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios.post("" + this.groupJoinRequestsEndpoint, {
                        group_id: groupId,
                        text: text,
                    })];
            });
        });
    };
    GroupsService.prototype.cancelGroupJoinRequest = function (groupJoinRequestUuid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios.delete(this.groupJoinRequestsEndpoint + "/" + groupJoinRequestUuid)];
            });
        });
    };
    GroupsService.prototype.approveGroupJoinRequest = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.patch(this.groupJoinRequestsEndpoint + "/" + id + "/approve")];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupsService.prototype.denyGroupJoinRequest = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.patch(this.groupJoinRequestsEndpoint + "/" + id + "/deny")];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupsService.prototype.addGroupUser = function (groupId, userId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.post(this.groupUserEndpoint, {
                            group_id: groupId,
                            user_id: userId,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GroupsService.prototype.membershipInvitationEmail = function (groupUuid, emails) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.post(this.membershipInvitationEndpoint + "/" + groupUuid + "/invite", {
                            emails: emails.split(',')
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GroupsService.prototype.membershipInvitationLink = function (groupUuid) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.get(this.membershipInvitationLinkEndpoint + "/" + groupUuid + "/generate")];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GroupsService = __decorate([
        injectable()
    ], GroupsService);
    return GroupsService;
}());
export { GroupsService };
